var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zhuzhidianjing-page"},[_c('navBar',{on:{"goBack":_vm.gobackChapter}},[_c('span',{staticClass:"title"},[_vm._v("主旨点睛")])]),_c('textImgContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }